module.exports = __webpack_public_path__ + "img/center front length from waist to hem.d9b18e27.png";